import i18n from 'i18next';
const { buildYup } = require('schema-to-yup');

function getYupFieldType(type) {
  let yupType = null;

  switch (type.toLowerCase()) {
    case 'text':
    case 'textarea':
    case 'select':
    case 'email':
    case 'date':
    case 'tel':
    case 'styled_button':
      yupType = 'string';
      break;
    default:
      yupType = type.toLowerCase();
      break;
  }
  return yupType;
}

function getYupFormat(type) {
  let yupFormat = '';

  switch (type.toLowerCase()) {
    case 'email':
      yupFormat = 'email';
      break;
    case 'date':
      yupFormat = 'date';
      break;
    default:
      break;
  }
  return yupFormat;
}

function generateJsonSchema(form) {
  const fields = {};
  const properties = {};
  const requiredFields = [];

  const schema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    type: 'object',
    properties: properties,
    required: requiredFields,
  };

  const validationMessages = {
    required: i18n.t('required', { ns: 'validation' }),
    format: i18n.t('email', { ns: 'validation' }),
  };

  const config = {
    errMessages: {},
  };

  form.forEach((field) => {
    fields[field.input.name] = field.input.value || '';

    if (field.input.type.toLowerCase() !== 'hidden') {
      properties[field.input.name] = {
        type: getYupFieldType(field.input.type),
        format: getYupFormat(field.input.type),
      };
      config.errMessages[field.input.name] = validationMessages;
    }

    if (field.input.type.toLowerCase() !== 'hidden' && field.input.required)
      requiredFields.push(field.input.name);
  });

  return { schema, config };
}

export function generateYup(form) {
  const { schema, config } = generateJsonSchema(form);
  return buildYup(schema, config);
}
